import axios from "axios";
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API_URL = `${BACKEND_URL}/api`;
export const authenticatedFileUrl = (fileId) => {
  if (!fileId) return "";
  const token = encodeURIComponent(localStorage.getItem("marsem_token") || "");
  return `${BACKEND_URL}/api/files/${fileId}?auth=${token}`;
};
export const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("marsem_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
